import { render, staticRenderFns } from "./ExtraBenefits.vue?vue&type=template&id=47f1784f&"
import script from "./ExtraBenefits.vue?vue&type=script&lang=js&"
export * from "./ExtraBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports